import React from "react";
import Chart from "react-apexcharts";

// Types
import { NonAxisChartProps } from "@/@types/ui/Charts";

export const DonutChart = (props: NonAxisChartProps) => {
  const { data, options } = props;

  const colors = ["#33b2df", "#546E7A", "#d4526e", "#13d8aa"];

  return (
    <Chart
      series={data.series}
      options={{ colors, ...options, labels: data.labels }}
      type="donut"
      height="300px"
    />
  );
};
